import type { Ari } from '@atlassian/jira-platform-ari/src/index.tsx';
import { getFields } from '../../../services/jpd-views-service/fetch-fields/index.tsx';
import { transformResponse } from './transform/index.tsx';

export const fetchFieldsFromViewsService = (viewId: Ari) =>
	getFields(viewId).then(transformResponse);
